<template>
	<v-footer
		v-if="!isLoggedIn && cookieConsent"
		:app="true"
		class="d-flex align-center justify-center ga-2 flex-wrap flex-grow-1 py-3"
		color="primary"
	>
		<v-btn
			href="https://www.aareon.de/Datenschutz.959299.html"
			ripple
			target="_blank"
			variant="text"
			>{{ t('common.privacy') }}
		</v-btn>
		<v-btn
			href="https://www.aareon.de/Impressum.959318.html"
			ripple
			target="_blank"
			variant="text"
			>{{ t('common.imprint') }}
		</v-btn>
		<v-btn href="https://info.aareon.de/de-de/immomanagement" variant="text" target="_blank">
			{{ dayjs().year() }} - Aareon Deutschland GmbH
		</v-btn>
	</v-footer>
</template>

<script setup lang="ts">
import { useDayJs } from '@/composables/dateTime'
import { useUserStore } from '@/stores/system'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const { dayjs } = useDayJs()
const { isLoggedIn, cookieConsent } = storeToRefs(useUserStore())
</script>

<style lang="scss" scoped></style>
